import type { Connection } from '../../api/types';

export function needsInitialEntitySelection(connection: Connection): boolean {
  return connection.status === 'connected'
    || connection.status === 'configuring'
    || (connection.status === 'draft'
      && (connection.connectorId === 'application_insights'
        || (connection.connector.authMethod === 'file_upload'
          && connection.connector.capabilities?.supports_entity_selection === true)));
}
